module.exports = __webpack_public_path__ + "img/10.76157f2d.jpg";